(function () {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 2999; // in cents (29,99 €)

  function fmt(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  // ──────────────────────────────────────────────────────────
  // CART DRAWER — Real Shopify /cart.js integration
  // ──────────────────────────────────────────────────────────
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function updateLine(line, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    return r.json();
  }

  function lineHTML(item, idx) {
    // Shopify cart.js: item.image (preferred), item.featured_image.url (fallback)
    const rawImg = item.image || (item.featured_image && item.featured_image.url) || '';
    const img = rawImg ? rawImg.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_200x.').replace('{width}', '200') : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return ''
      + '<div class="cart-line" data-idx="' + idx + '" data-line="' + (idx + 1) + '">'
      +   (img ? '<img class="cart-line__img" src="' + img + '" alt="">' : '<div class="cart-line__img"></div>')
      +   '<div class="cart-line__info">'
      +     '<div class="cart-line__cat">' + (item.product_type || item.vendor || '') + '</div>'
      +     '<div class="cart-line__title">' + item.product_title + '</div>'
      +     (variant ? '<div class="cart-line__variant">' + variant + '</div>' : '')
      +     '<div class="cart-line__qty">'
      +       '<button type="button" data-qty="-1" aria-label="Weniger">−</button>'
      +       '<input type="text" value="' + item.quantity + '" readonly>'
      +       '<button type="button" data-qty="1" aria-label="Mehr">+</button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="cart-line__right">'
      +     '<div class="cart-line__price">' + fmt(item.final_line_price) + '</div>'
      +     '<button class="cart-line__remove" type="button" data-remove>Entfernen</button>'
      +   '</div>'
      + '</div>';
  }

  function renderCart(cart) {
    const body = document.getElementById('CartDrawerBody');
    const headerCount = document.querySelectorAll('.cart-count, #CartCount');
    headerCount.forEach((el) => (el.textContent = cart.item_count));
    document.getElementById('CartDrawerCount').textContent = cart.item_count === 1 ? '1 Artikel' : cart.item_count + ' Artikel';

    if (!cart.items.length) {
      body.innerHTML = ''
        + '<div class="cart-empty">'
        + '<div class="cart-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 7h14l-1.5 11.5a2 2 0 0 1-2 1.5h-7a2 2 0 0 1-2-1.5L5 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg></div>'
        + '<h3 class="cart-empty__title">Dein Warenkorb ist <em>leer</em></h3>'
        + '<p class="cart-empty__sub">Entdecke unsere authentischen Schätze aus Marokko.</p>'
        + '<a href="/collections/all" class="cart-drawer__btn cart-drawer__btn--primary" style="display:inline-flex;">Jetzt entdecken →</a>'
        + '</div>';
    } else {
      body.innerHTML = cart.items.map(lineHTML).join('');
    }

    // Progress
    const sub = cart.total_price;
    const missing = Math.max(0, FREE_SHIPPING_THRESHOLD - sub);
    const fill = Math.min(100, (sub / FREE_SHIPPING_THRESHOLD) * 100);
    const progressEl = document.getElementById('CartProgress');
    if (missing > 0 && cart.items.length > 0) {
      progressEl.innerHTML = '<p class="cart-drawer__progress-text">Noch <strong>' + fmt(missing) + '</strong> bis zum <strong>kostenlosen Versand</strong> ab 29,99 €</p><div class="cart-drawer__progress-bar"><div class="cart-drawer__progress-fill" style="width:' + fill + '%;"></div></div>';
      progressEl.style.display = 'block';
    } else if (cart.items.length > 0) {
      progressEl.innerHTML = '<p class="cart-drawer__progress-text" style="color: var(--color-primary);"><strong>✓ Versand kostenlos</strong> — JazakAllahu Khayran!</p><div class="cart-drawer__progress-bar"><div class="cart-drawer__progress-fill" style="width:100%; background: var(--color-primary);"></div></div>';
      progressEl.style.display = 'block';
    } else {
      progressEl.style.display = 'none';
    }

    document.getElementById('CartSubtotal').textContent = fmt(sub);
    document.getElementById('CartTotal').textContent = fmt(sub);
  }

  async function openCart(prefetched) {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const cart = prefetched || (await fetchCart());
    renderCart(cart);
  }
  function closeCart() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Open via cart icon
  document.querySelectorAll('[aria-label="Warenkorb"]').forEach((el) => {
    if (el.closest('#CartDrawer')) return;
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });
  drawer.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeCart));

  // Line interactions (qty +/-, remove)
  drawer.addEventListener('click', async (e) => {
    const lineEl = e.target.closest('.cart-line');
    if (!lineEl) return;
    const lineNum = parseInt(lineEl.dataset.line);
    if (e.target.closest('[data-remove]')) {
      const cart = await updateLine(lineNum, 0);
      renderCart(cart);
    } else if (e.target.closest('[data-qty]')) {
      const delta = parseInt(e.target.closest('[data-qty]').dataset.qty);
      const input = lineEl.querySelector('input');
      const newQty = Math.max(0, parseInt(input.value) + delta);
      const cart = await updateLine(lineNum, newQty);
      renderCart(cart);
    }
  });

  // Listen for cart updates from theme.js (after quick-add) — opens drawer with fresh data
  document.addEventListener('cart:updated', (e) => {
    const cart = e.detail && e.detail.cart;
    const shouldOpen = e.detail && e.detail.openDrawer;
    if (cart) renderCart(cart);
    if (shouldOpen) openCart(cart);
  });

  // ──────────────────────────────────────────────────────────
  // MOBILE MENU
  // ──────────────────────────────────────────────────────────
  const mm = document.getElementById('MobileMenu');
  function openMM() {
    mm.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMM() {
    mm.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  mm.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeMM));
  mm.querySelectorAll('[data-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => btn.parentElement.classList.toggle('is-open'));
  });

  // Inject hamburger button BEFORE the logo (left side of header on mobile)
  const headerInner = document.querySelector('.site-header__inner');
  const headerLogo = document.querySelector('.site-header__logo');
  if (headerInner && headerLogo && !document.querySelector('.header-hamburger')) {
    const ham = document.createElement('button');
    ham.className = 'header-hamburger';
    ham.setAttribute('aria-label', 'Menü');
    ham.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
    ham.addEventListener('click', openMM);
    headerInner.insertBefore(ham, headerLogo);
  }

  // ──────────────────────────────────────────────────────────
  // NEWSLETTER POPUP — once per visitor, 8s delay
  // ──────────────────────────────────────────────────────────
  const nl = document.getElementById('NewsletterPopup');
  const NL_KEY = 'da-newsletter-popup-seen';

  function openNL() {
    nl.classList.add('is-open');
  }
  function closeNL() {
    nl.classList.remove('is-open');
    localStorage.setItem(NL_KEY, '1');
  }
  if (nl) {
    nl.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeNL));
    // Don't show on cart/checkout/account pages or if already seen
    const skipPaths = ['/cart', '/checkout', '/account'];
    const skip = skipPaths.some((p) => window.location.pathname.startsWith(p));
    if (!localStorage.getItem(NL_KEY) && !skip) {
      setTimeout(openNL, 8000);
    }
    // If form was just submitted successfully, show the popup with success state
    if (nl.querySelector('#NlPopupSuccess')) {
      openNL();
      localStorage.setItem(NL_KEY, '1');
      setTimeout(closeNL, 5000);
    }
  }

  // Initial cart fetch on page load — pre-render so drawer shows real data instantly when opened
  fetchCart().then((cart) => {
    renderCart(cart);
  }).catch(() => {});

  // Debug helpers
  window.__darAssalam = { openCart, closeCart, openMM, closeMM, openNL, closeNL };
})();
